export default "__VITE_ASSET__Dan6ELGh__"